export function getCookie(name) {
  if (document.cookie.indexOf(name) > -1) {
    return document.cookie.split(name)[1].split("; ")[0].substr(1);
  }
  return undefined;
}

export function getUserAuthValues() {
  var obj = decodeURIComponent(getCookie("userid") || "").split("|");

  return {
    email: obj[0],
    profileName: obj[1],
    gender: obj[2],
    photo: obj[3],
    userId: obj[4],
  };
}

export function isEmpty(obj) {
  if (obj instanceof Date) {
    return false;
  }
  // null and undefined are "empty"
  if (obj == null) {
    return true;
  }

  var isNumber = function (value) {
    return Object.prototype.toString.call(value) === "[object Number]";
  };

  var isNaN = function (value) {
    return isNumber(value) && value.toString() === "NaN";
  };

  if (isNumber(obj)) {
    return isNaN(obj);
  }

  /** Assume if it has a length property with a non-zero value
   * that that property is correct.
   */
  if (obj.length > 0) {
    return false;
  }
  if (obj.length === 0) {
    return true;
  }

  /** If it isn't an object at this point
   * it is empty, but it can't be anything *but* empty
   * Is it empty?  Depends on your application.
   */
  if (typeof obj !== "object") {
    return true;
  }

  /**  Otherwise, does it have any properties of its own?
   * Note that this doesn't handle
   * toString and valueOf enumeration bugs in IE < 9
   */
  var keys = Object.keys(obj);
  for (var i = 0, key = keys[i]; i < keys.length; i += 1) {
    if (hasOwnProperty.call(obj, key)) {
      return false;
    }
  }
  return true;
}

export function loadStyle(url, callback) {
  let link = document.createElement("link");
  link.type = "text/css";
  link.rel = "stylesheet";
  link.onload = callback;
  link.href = url;

  let headScript = document.querySelector("script");
  headScript.parentNode.insertBefore(link, headScript);
}

/**
 * Synchronously checks if the current domain is Flyin.
 * This function checks multiple sources to prevent theme flash:
 * 1. window.__IS_FLYIN__ - set by inline script in HTML head (fastest)
 * 2. data-theme attribute on documentElement
 * 3. window.location.href check (fallback)
 * 
 * @returns {boolean} true if Flyin domain, false otherwise
 */
export const isFlyin = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  
  // Check window variable set by inline script (fastest, prevents flash)
  if (window.__IS_FLYIN__ !== undefined) {
    return window.__IS_FLYIN__;
  }
  
  // Fallback to data attribute set by inline script
  if (typeof document !== 'undefined') {
    const theme = document.documentElement.getAttribute('data-theme');
    if (theme === 'flyin') return true;
    if (theme === 'cleartrip') return false;
  }
  
  // Final fallback to location check
  if (window.location && window.location.href) {
    return window.location.href.includes('flyin.com');
  }
  
  return false;
}

export function twitterWidget() {
  (function (d, s, id) {
    let js;
    let fjs = d.getElementsByTagName(s)[0];
    let p = /^http:/.test(d.location) ? "http" : "https";
    if (!d.getElementById(id)) {
      js = d.createElement(s);
      js.id = id;
      js.src = p + "://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);
    }
  })(document, "script", "twitter-wjs");
}

export const path = (p, o) => {
  const reducerFunction = (xs, x) => {
    return xs && xs[x] ? xs[x] : null
  }
  return p.reduce(reducerFunction, o)
}

export const getLanguageMeta = () => {
  const domain = path(['location', 'hostname'], window) // window.location.hostname;
  switch (domain) {
    case 'www.cleartrip.ae':
    case 'qa2.cleartrip.ae':
    case 'me.cleartrip.ae':
    case 'uat.cleartrip.ae':
        return { locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' }
    case 'bh.cleartrip.com':
    case 'qa2bh.cleartrip.com':
    case 'bh.cleartrip.sa':
    case 'uat.cleartrip.bh':
    case 'www.cleartrip.bh':
        return { locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' }
    case 'om.cleartrip.com':
    case 'qa2om.cleartrip.com':
    case 'om.cleartrip.sa':
    case 'uat.cleartrip.om':
    case 'www.cleartrip.om':
        return { locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' }
    case 'kw.cleartrip.com':
    case 'qa2kw.cleartrip.com':
    case 'kw.cleartrip.sa':
    case 'uat.cleartrip.com.kw':
    case 'www.cleartrip.kw':
        return { locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' }
    case 'qa.cleartrip.com':
    case 'qa2qa.cleartrip.com':
    case 'qar.cleartrip.sa':
    case 'uat.cleartrip.qa':
    case 'www.cleartrip.qa':
        return { locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'QAR' }
    case 'www.cleartrip.sa':
    case 'qa2.cleartrip.sa':
    case 'me.cleartrip.sa':
    case 'uat.cleartrip.sa':
        return { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' }
    case 'qa2.cleartrip.com':
        return { locale: 'IN', currency: 'INR', country: 'IN', symbol: '₹' }
    case 'me.cleartrip.com':
    case 'qa2me.cleartrip.com':
        return { locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' }
    case 'www.cleartrip.me':
        return { locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' }
    case 'www.cleartrip.eu':
        return { locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' }
    case 'www.cleartrip.pl':
        return { locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' }
    case 'www.cleartrip.co.za':
        return { locale: 'ZA', currency: 'ZAR', country: 'ZA', symbol: 'R' }
    default:
        return { locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' }
}
}

export const checkDeviceType = () => {
  let deviceType = null
  if (window.parent.androidData && window.parent.androidData["app-agent"] && window.parent.androidData[ 'js-version']) {
    deviceType = 'AndroidApp'
  }
  if (window.parent.iosData && window.parent.iosData["app-agent"] && window.parent.iosData['js-version']) {
    deviceType = 'iPhoneApp'
  }
  if (path(['sessionStorage'], window) && typeof window.parent.sessionStorage != 'undefined') {
    deviceType = sessionStorage.getItem('mobileApp')
  }
  return deviceType
}

export const isSessionStorageValid = ()=>{
  return  window && window?.sessionStorage && window?.sessionStorage !==' undefined'
}

export const isMobileSite = () => {

    let returnFlag = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i.test(navigator.userAgent)) {
      returnFlag = true;
    }
    return returnFlag;
}

export const onPageStart = (type = '') => {
  if (path(['androidData', 'app-agent'], window) && path(['androidData', 'js-version'], window)) {
      if (path(['sessionStorage'], window) && typeof window.sessionStorage != 'undefined') {
          sessionStorage.setItem('mobileApp', 'AndroidApp')
      }
      window.MobileApp.onPageStart(type)
  }
  if (path(['iosData', 'app-agent'], window) && path(['iosData', 'js-version'], window)) {
      if (path(['sessionStorage'], window) && typeof window.sessionStorage != 'undefined') {
          sessionStorage.setItem('mobileApp', 'iPhoneApp')
      }
      if (path(['webkit', 'messageHandlers'], window) && window.webkit.messageHandlers[type]) {
          window.webkit.messageHandlers[type].postMessage('')
      }
  }
}